<template>
  <v-card
    class="pa-4"
    flat
  >
    <h1>{{ $t('playerSettings.title') }}</h1>
    <br>
    <custom-table
      icon="mdi-cellphone-android"
      title="playerSettings.title"
      :headers="[{
          text: $t('playerSettings.name'),
          align: 'left',
          sortable: false,
          value: 'ident',
        },
        {
          text: $t('playerSettings.delay'),
          align: 'center',
          sortable: false,
          value: 'delay',
        },
        {
          text: $t('playerSettings.token'),
          align: 'left',
          sortable: false,
          value: 'token',
        }
      ]"
      :data="data"
      :count="count"
      :loading="loading"
      :onAdd="handleAdd"
      :onSearch="handleChangeSearch"
    />
  </v-card>
</template>

<script>
  import api from '@/services/api'
  import CustomTable from '@/components/CustomTable'
  export default {
    components: {
      CustomTable
    },
    data: () => ({
      page: 1,
      count: 0,
      itemPerPage: 10,
      searchValue: '',
      data: [],
      loading: false
    }),
    computed: {
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
    },
    mounted () {
      this.handleGetPlayers()
    },
    methods: {
      handleChangeSearch (searchValue, page) {
        this.searchValue = searchValue
        this.page = page
        this.handleGetPlayers()
      },
      handleGetPlayers () {
        let www = process.env.VUE_APP_ENV === 'development' ? '' : 'www.'
        this.loading = true
        api.getAll(`enterprises/${this.enterpriseID}/players`, true, this.page, this.itemPerPage, this.searchValue).then(response => {
          this.count = response.count
          this.data = response.data.map(item => {
            return ({
              ident: {
                id: item.ID,
                name: item.Name
              },
              delay: item.Delay,
              token: `${window.location.protocol}//${www}${process.env.VUE_APP_API_URL}/private/pings?token=${item.Token}`
            })
          })
          this.loading = false
        })
      },
      handleAdd () {
        this.$router.push('/players/new')
      }
    }
  }
</script>
